import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then(
        (mod) => mod.MainLayoutComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./feature/dashboard/dashboard.component').then(
            (mod) => mod.DashboardComponent
          ),
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./feature/dashboard/dashboard.component').then(
            (mod) => mod.DashboardComponent
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./feature/orders/orders.routes').then((m) => m.orderRoutes),
      },
    ],
    //canActivate: [AuthGuard],
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./feature/login/login.component').then(
        (mod) => mod.LoginComponent
      ),
  },

  {
    path: '',
    loadComponent: () =>
      import('./feature/login/login.component').then(
        (mod) => mod.LoginComponent
      ),
  },
];
